const getters = {
  isMobile: state => state.pageInfo.isMobile,
  language: state => state.pageInfo.language,
  currentId: state => state.swiper.currentId,
  layoutOptions: state => state.pageInfo.layoutOptions
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js